import welcomeCoverDesktop from "../../assets/images/background-images/bg_desktop.png";
import welcomeCoverGreenDesktop from "../../assets/images/background-images/bg_desktop_green.png";
import welcomeCoverMobile from "../../assets/images/background-images/bg_mobile.png";
import welcomeCoverGreenMobile from "../../assets/images/background-images/bg_mobile_green.png";
import carePlanPageHeader from "../../assets/images/background-images/bg_care_plan_page_header.png";
import carePlanPageHeaderMobile from "../../assets/images/background-images/bg_care_plan_page_header_mobile.png";
import curvedBgWhite from "../../assets/images/background-images/bg_curved_desktop.png";
import curvedBgWhiteMobile from "../../assets/images/background-images/bg_curved_mobile.png";
import curvedBgPeachDesktop from "../../assets/images/background-images/bg_learning_desktop.png"
import curvedBgPeachMobile from "../../assets/images/background-images/bg_learning_mobile.png"
import learningCategoryBgDesktop from "../../assets/images/background-images/bg_learning_category.png"
import learningCategoryBgMobile from "../../assets/images/background-images/bg_learning_category_mobile.png"

const backgroundConfig = {
  welcomeOverviewDesktop: {
    coverImage: welcomeCoverDesktop,
  },
  welcomeOverviewMobile: {
    coverImage: welcomeCoverMobile,
  },
  welcomeCoverGreenDesktop: {
    coverImage: welcomeCoverGreenDesktop,
  },
  welcomeCoverGreenMobile: {
    coverImage: welcomeCoverGreenMobile,
  },
  carePlanPageDesktop: {
    coverImage: carePlanPageHeader,
  },
  carePlanPageMobile: {
    coverImage: carePlanPageHeaderMobile,
  },
  dashboard: {
    coverImage: "",
  },
  babyWeekImageDesktop: {
    coverImage: curvedBgWhite,
  },
  babyWeekImageMobile: {
    coverImage: curvedBgWhiteMobile,
  },
  learningImageDesktop: {
    coverImage: curvedBgPeachDesktop
  },
  learningImageMobile: {
    coverImage: curvedBgPeachMobile
  },
  learningCategoryImageDesktop: {
    coverImage: learningCategoryBgDesktop
  },
  learningCategoryImageMobile : {
    coverImage: learningCategoryBgMobile
  },
  default: {
    coverImage: "",
  },
};

export default backgroundConfig;
